import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="bg-white py-20 px-6 border-y border-brand-navy/5" data-id="element-165">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-166">
        <FadeIn data-id="element-167">
          <p className="text-lg md:text-xl leading-relaxed text-brand-gray" data-id="element-168">
            Most parents try to solve the "phone problem" with screen-time locks
            and constant nagging. You've suggested a "real job" at the mall or
            folding shirts for minimum wage, but your teen isn't interested—and
            honestly, those jobs don't teach them the skills they need for the
            21st century.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-169">
          <p className="text-lg md:text-xl leading-relaxed text-brand-gray" data-id="element-170">
            Meanwhile, the local coffee shop, the landscaper down the street,
            and the family-owned gym are{' '}
            <strong className="text-brand-navy" data-id="element-171">invisible online</strong>. They
            know they need to "do social media," but they are too busy running
            their businesses to figure out Reels, TikToks, or community
            engagement.
          </p>
        </FadeIn>
      </div>
    </section>;
}